import type { SheetRow } from './types';

/**
 * Local row id generator. Persisted rows reuse the backend `_id`; newly-added
 * rows need a stable local id so React keys + selection survive across the
 * many edits a user typically stacks before hitting Save all.
 */
let counter = 0;
export function makeSheetRowId(): string {
  counter += 1;
  return `row_local_${Date.now()}_${counter}`;
}

/**
 * Blank row factory used by "+ Add row" and the bulk-duplicate fallback when
 * no template is available. Defaults to a one-way ambient goods rate at $0;
 * `isRowSavable` will keep this out of the persistence fan-out until the user
 * fills in origin + destination + vehicles + a non-zero price.
 */
export function emptyRow(): SheetRow {
  return {
    id: makeSheetRowId(),
    routeId: null,
    origin: null,
    destination: null,
    vehicles: [],
    tripType: 'one_way',
    loadType: 'goods',
    temperatureType: ['dry'],
    price: 0,
    status: 'new',
  };
}
